<template>
	 <v-content>
    <the-header menuTitle="Flight Report" />
    <v-container class="page-wrapper" style="min-height: 700px;">
      <div class="text-xs-center"  v-if="dialog">
         <v-dialog
            v-model="dialog"
            hide-overlay
            persistent
            width="300"
          >
               <v-card
                  color="primary"
                  dark
                >
                  <v-card-text>
                    Please stand by
                    <v-progress-linear
                      indeterminate
                      color="white"
                      class="mb-0"
                    ></v-progress-linear>
                  </v-card-text>
              </v-card>
          </v-dialog>
       </div>
       <div v-else>
        <ReportDetail></ReportDetail>
      </div>
    </v-container>
    <!--  <the-footer style="margin-bottom:-44px" /> -->
   <!--  <v-footer class="footer" style="margin-bottom:-44px">
        &#169; {{ new Date().getFullYear() }} Advenue. All rights reserved. Build:{{ new Date().getDate().toString().padStart(2, "0")}}{{new Date().getMonth().toString().padStart(2, "0")}}{{ new Date().getFullYear()}}-1
    </v-footer> -->
  </v-content>
</template>

<script>
 //
  import TheHeader from "@/components/TheHeader";
  import TheFooter from "@/components/TheFooter";
  import ReportDetail from '@/components/ReportDetail';
  //import FlightRequest from '@/components/FlightRequest';
  //import HelloWorld from '../components/HelloWorld'

  export default {

    components: {
      TheHeader,
      TheFooter,
      ReportDetail,

    },
   data () {
      return {
        dialog: false
      }
    },
   mounted(){
    //  console.log(this.$store.state.isLoading);
//     (23018) (REPORT)MY/Honda/HEV Sustenance Mar'18
// (22987) (REPORT)MY/Honda/City PET Sustenance Mar'18
// (22946) (REPORT)MY/Honda/CRV Sustenance Mar'18
      this.dialog = this.$store.state.isLoading
      //console.log(this.dialog)
    },
    watch: {
      dialog (val) {
        if (!val) return

        setTimeout(() => (this.dialog = false), 3000)
      }
    }
  }
</script>
